import { useCallback, useState } from 'react'
import { resolveApiUrl } from '@/lib/api'

export function useMasterAutopilot() {
  const [status, setStatus] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const run = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch(resolveApiUrl('/master/autopilot/run'), { method: 'POST' })
      if (!response.ok) {
        throw new Error(`Autopilot ${response.status}`)
      }
      const payload = await response.json()
      const count = Array.isArray(payload?.runs) ? payload.runs.length : 0
      setStatus(`Triggered ${count} agents`)
      return payload
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return { run, status, error, loading }
}
